import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  radioGroup: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "-10px",
  },
  button: {
    marginTop: "20px",
  },
}));
